import { IconButton, Tooltip } from '@mui/material'
import DeleteIcon from 'icons/DeleteIcon'
import EditIcon from 'icons/EditIcon';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from 'styles/colors';

interface Props {
  id: number;
  refetch?: () => void;
}

export default function EditProcedureButton({ id }: Props) {
  const navigate = useNavigate();

  const handlePress = useCallback(() => {
    navigate(`/patients/${id}/edit`)
  }, [id, navigate]);

  return (
    <Tooltip title={'Edit'}>
      <IconButton
      onClick={handlePress}
        sx={{
          width: 25,
          height: 25,
          backgroundColor: colors.appeal,
          borderRadius: '4px',
          padding: 0,
          '&:hover': {
            backgroundColor: colors.appeal,
          },
        }}
      >
        <EditIcon size={12} color='white' />
      </IconButton>
    </Tooltip>
  )
}
